export default "__VITE_ASSET__Bf5Sv$cX__"